export default "__VITE_PUBLIC_ASSET__57157728__"